import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const concatenate = (first, second) => {
    const generator = async () => {
        const [firstData, secondData] = await Promise.all([first.toArray(), second.toArray()]);
        return [...firstData, ...secondData];
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
